import React from 'react';

import RecommendationList from 'buyside/components/presentation/ProfileRecommendationCard/profileRecommendationList';

import StarIcon from 'buyside/svgs/star.svg';
import {
  FundProfileRecommendationFragment,
  FundProfileCardFragment,
  AllocatorProfileCardFragment,
  AllocatorProfileRecommendationFragment
} from 'interfaces/graphql-typings';

import styles from './fundRecommendationHeaderStyles.scss';

export interface FundRecommendationType extends FundProfileRecommendationFragment {
  assetClassesMatching: string[];
  geographiesMatching: string[];
  matchesGeographies: boolean;
  matchesAssetClasses: boolean;
  matchesSectors: boolean;
  sectorsMatching: string[];
}

const FundRecommendationHeader: React.FC<{
  fundRecommendation: FundRecommendationType | AllocatorProfileRecommendationFragment;
  recommendedFundProfile?: FundProfileCardFragment;
  recommendedAllocatorProfile?: AllocatorProfileCardFragment;
}> = ({
  fundRecommendation,
  recommendedFundProfile,
  recommendedAllocatorProfile
}): React.ReactElement => {
  const {
    matchesFundType,
    matchesStrategy,
    matchesAumRange,
    matchesGeographies,
    geographiesMatching,
    matchesSectors,
    sectorsMatching,
    matchesAssetClasses,
    assetClassesMatching
  } = fundRecommendation;

  const aumRange = recommendedFundProfile?.aumRange || recommendedAllocatorProfile?.aumRange;

  return (
    <div className={styles.recommendationContainer}>
      <div className={styles.headerText}>
        <StarIcon className={styles.starIcon} />
        Recommended for you based on:
      </div>
      <div className={styles.recommendationArea}>
        <div>
          {matchesFundType && recommendedFundProfile && (
            <div>
              Firm Type: <em>{recommendedFundProfile.fundType}</em>
            </div>
          )}
          {matchesStrategy && recommendedFundProfile && (
            <div>
              Strategy: <em>{recommendedFundProfile.strategy}</em>
            </div>
          )}
          {matchesAumRange && aumRange && (
            <div>
              Aum Range: <em>{aumRange}</em>
            </div>
          )}
        </div>
        <div>
          {matchesGeographies && geographiesMatching && (
            <RecommendationList title="Geographies" listItems={geographiesMatching} />
          )}
          {matchesSectors && sectorsMatching && (
            <RecommendationList title="Sectors" listItems={sectorsMatching} />
          )}
          {matchesAssetClasses && assetClassesMatching && (
            <RecommendationList title="Asset Classes" listItems={assetClassesMatching} />
          )}
        </div>
      </div>
    </div>
  );
};

export default FundRecommendationHeader;
